/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * How the client authenticates at the provider token endpoint, or the preferred method for DCR.
 */
export const ServerIdentityClientConfigurationTokenEndpointAuthMethod = {
  ClientSecretBasic: "client_secret_basic",
  ClientSecretPost: "client_secret_post",
  None: "none",
} as const;
/**
 * How the client authenticates at the provider token endpoint, or the preferred method for DCR.
 */
export type ServerIdentityClientConfigurationTokenEndpointAuthMethod =
  ClosedEnum<typeof ServerIdentityClientConfigurationTokenEndpointAuthMethod>;

/**
 * Configuration for a newly-created project remote-session client. Manual mode requires client_id. Auto mode forbids client_id and client_secret and uses scope, audience, and token_endpoint_auth_method as registration preferences.
 */
export type ServerIdentityClientConfiguration = {
  /**
   * Optional upstream OAuth audience.
   */
  audience?: string | undefined;
  /**
   * The out-of-band OAuth client identifier. Manual mode only.
   */
  clientId?: string | undefined;
  /**
   * The out-of-band OAuth client secret. Manual mode only; encrypted before persistence.
   */
  clientSecret?: string | undefined;
  /**
   * Each value must be an RFC 6749 scope token.
   */
  scope?: Array<string> | undefined;
  /**
   * How the client authenticates at the provider token endpoint, or the preferred method for DCR.
   */
  tokenEndpointAuthMethod?:
    | ServerIdentityClientConfigurationTokenEndpointAuthMethod
    | undefined;
};

/** @internal */
export const ServerIdentityClientConfigurationTokenEndpointAuthMethod$outboundSchema:
  z.ZodMiniEnum<
    typeof ServerIdentityClientConfigurationTokenEndpointAuthMethod
  > = z.enum(ServerIdentityClientConfigurationTokenEndpointAuthMethod);

/** @internal */
export type ServerIdentityClientConfiguration$Outbound = {
  audience?: string | undefined;
  client_id?: string | undefined;
  client_secret?: string | undefined;
  scope?: Array<string> | undefined;
  token_endpoint_auth_method?: string | undefined;
};

/** @internal */
export const ServerIdentityClientConfiguration$outboundSchema: z.ZodMiniType<
  ServerIdentityClientConfiguration$Outbound,
  ServerIdentityClientConfiguration
> = z.pipe(
  z.object({
    audience: z.optional(z.string()),
    clientId: z.optional(z.string()),
    clientSecret: z.optional(z.string()),
    scope: z.optional(z.array(z.string())),
    tokenEndpointAuthMethod: z.optional(
      ServerIdentityClientConfigurationTokenEndpointAuthMethod$outboundSchema,
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      clientId: "client_id",
      clientSecret: "client_secret",
      tokenEndpointAuthMethod: "token_endpoint_auth_method",
    });
  }),
);

export function serverIdentityClientConfigurationToJSON(
  serverIdentityClientConfiguration: ServerIdentityClientConfiguration,
): string {
  return JSON.stringify(
    ServerIdentityClientConfiguration$outboundSchema.parse(
      serverIdentityClientConfiguration,
    ),
  );
}
